import { render, staticRenderFns } from "./SignatureEdit.vue?vue&type=template&id=5ef2f076&scoped=true&lang=pug"
import script from "./SignatureEdit.vue?vue&type=script&lang=js"
export * from "./SignatureEdit.vue?vue&type=script&lang=js"
import style0 from "./SignatureEdit.vue?vue&type=style&index=0&id=5ef2f076&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2f076",
  null
  
)

export default component.exports